const en = {
  home: 'Home',
  najizData: 'Najiz data',
  intro: {
    subTitle: 'Subscription-based model to provide quick access to meet business need.',
  },
  openData: {
    title: 'Open data',
    description: 'You can obtain open data directly from here, and additional data is requested if the data is insufficient for your request, provided that the request does not include private or confidential data.',
    showData: 'Show data',
    downloadText: 'Possibility of downloading open data',
  },
  openDataPolicy: {
    title: 'Open data policy',
    introText: 'The provisions of this policy apply to all public data and information produced by the Ministry of Justice.',
    purposeText: 'The purpose of this policy is to establish the most important regulatory controls for sharing open data with beneficiaries inside and outside the Ministry. Open data is considered a subsidiary of public information.',
    methodsText: 'The beneficiary can also obtain data by browsing the interactive reports listed on the home page, moving to its details page, exporting the information to an Excel file, or requesting additional data via the form.',
    dataTypes: {
      title: 'This policy applies to open data that is shared with entities inside and outside the Ministry for the purpose of disseminating the work and services of the judicial facility and raising the level of knowledge and judicial culture and providing that. It includes the following:',
      firstTitle: 'Interactive forensic reports in its various sections: (judicial reports, implementation reports, documentation reports, real estate transaction reports) in addition to publishing them on the national open data platform and making forensic data related to beneficiary services, systems development, international cooperation and human resources development available.',
      firstPrefix: 'Firstly:',
      secondTitle: 'Statistical yearbook.',
      secondPrefix: 'secondly:',
      thirdTitle: 'Judicial Journal.',
      thirdPrefix: 'Third:',
      fourthTitle: 'Rulings and case law.',
      fourthPrefix: 'Fourthly:',
    },
    usageInstructions: {
      title: 'Instructions for use:',
      text1: 'The Ministry of Justice must be referred to when using its data in the References section in order to preserve the Ministry’s intellectual property.',
      text2: 'When using Ministry of Justice data, it must be preserved and not modified.',
      text3: 'This data must not be used for political or racist purposes towards a class, race or religion or to support any illegal activity.',
    },
    usersResponsibility: {
      title: 'Responsibility of data users:',
      text1: 'Users of Ministry of Justice data have the right to conduct any studies of any kind, provided that they maintain the integrity, validity, and accuracy of the data.',
      text2: 'The results of studies that are published must be free of errors related to the validity, integrity and accuracy of the data.',
      text3: 'The Ministry is pleased to share the results of the studies with it through the Data and Privacy Management Office to develop its justice system.',
    },
    mojResponsibility: {
      title: 'Responsibility of the Ministry of Justice:',
      text1: 'The Ministry of Justice disclaims any responsibility for any damage or loss that may befall users or individuals of its published data.',
      text2: 'This published data may change or be deleted as a result of periodic data updating; The Ministry does not guarantee the continued availability of this data.',
    },
    publishingRequirements: {
      title: 'Open data publishing requirements:',
      text1: 'Approval for publication by the Open Data and Information Officer.',
    },
    principles: {
      title: 'Key principles of open data',
      availability: 'Origin of data availability:',
      availabilityDescription: 'Ensures that the Ministry\'s public data is made available to everyone by disclosing it, enabling access to it, or using it unless its nature requires not disclosing it or protecting its privacy or confidentiality.',
      freshness: 'Data freshness:',
      freshnessDescription: 'The latest version of the dataset is published.',
      comprehensiveness: 'Comprehensiveness:',
      comprehensivenessDescription: 'Open datasets must be comprehensive, include as much detail as possible, and reflect registered data in a way that does not conflict with the personal data protection policy.',
      discrimination: 'Non-discrimination:',
      discriminationDescription: 'Datasets should be made available to everyone without discrimination and without the need to register on the platform.',
      financial: 'Without any financial compensation:',
      financialDescription: 'Open data should be freely available to everyone.',
      openDataLicense: 'Open data license in the Kingdom:',
      openDataLicenseDescription: 'Open data must be subject to a license that defines the regulatory basis for using open data as well as the conditions and obligations.',
      governanceDevelopment: 'Developing a governance model and engaging everyone:',
      governanceDevelopmentDescription: 'Open data enables access and participation for all, enhances the transparency and accountability of public entities, and supports the decision-making process and service delivery.',
      developmentAndInnovation: 'Comprehensive development and innovation:',
      developmentAndInnovationDescription: 'Reuse of open data must be promoted. There must also be integration between various entities to prepare a next generation of innovators in the field of open data and to involve individuals and institutions in general.',
    },
  },
  additionalData: {
    title: 'Request additional data',
    description: 'A service that allows the private sector to obtain additional data tailored to meet their needs, provided that the request does not include private or confidential data.',
    serviceSteps: 'Steps to apply for the service',
    step1: 'Check the National Facility Register.',
    step2: 'Fill in the required data.',
    step3: 'Select additional data details.',
    step4: 'Submit application.',

    youShouldKnow: 'You should know',
    feesHint: 'Service fees may apply.',
    startService: 'Start service',
  },
  faqsTitle: 'How can we benefit from open data?',
  applicantName: 'Applicant name',
  applicantNamePlaceholder: 'Enter applicant name',
  mobile: 'Mobile number',
  mobilePlaceholder: '05xxxxxxxx',
  email: 'Email address',
  emailPlaceholder: 'John.doe@email.com',
  companyName: 'Company name',
  companyNamePlaceholder: 'Enter company name',
  requestDataType: 'Request data type',
  requestDataTypePlaceholder: 'Select data type',
  requestDescription: 'Purpose of data use',
  requestDescriptionPlaceholder: 'Add description',
  agreement: 'I, the person whose information is mentioned above, acknowledge and pledge that the information entered in the application is correct, and I bear responsibility for the consequences thereof.',
  submitRequest: 'Submit request',
  additionalRequestDataConfirmationTitle: 'Your request has been submitted successfully',
  additionalRequestDataConfirmationTitleDescription: 'Your application has been received, will be reviewed, and you will be notified through the contact information attached to the application to complete the procedures',
  theName: 'Name',
  backToNajizData: 'Back to najiz data',
  next: 'next',
  cancel: 'cancel',
  previous: 'previous',
  applicantInfo: 'Applicant data',
  requestDetails: 'Request details',
  requestPreview: 'Request preview',
  organizationNationalNumber: 'Organization national number',
  nationalIdNumber: 'National Id number',
  verify: 'verify',
  backToVerify: 'Back to verify',
  organizationCRType: 'Organization cr type',
  organizationName: 'Organization name',
  unAvailable: 'Un available',
  pleaseVerifyApplicantData: 'Please verify applicant data',
  retreat: 'retreat',
  rejectRequest: 'reject request',
  cancelRequestConfirmation: 'Do you want to cancel the request ?',
  cancelRequestConfirmationText: 'Cancel request confirmation Text',
  organizationVerificationError: 'Sorry, you cannot submit a request for additional data.',
  organizationVerificationErrorDescription: 'A dedicated service for Najiz Business accounts. Please activate your account via the Business Account Activation Service.',
  clickHere: 'Click here',
  contactInfo: 'Contact info',
  additionalPhoneNumber: 'Additional phone number',
  additionalDataDetails: 'Additional data details',
  edit: 'Edit',
  requestStatus: 'Request status',
  requestSuccessMessage: 'Your request has been submitted successfully',
  requestSuccessDescription: 'Your application has been received, will be reviewed, and you will be notified through the contact information attached to the application to complete the procedures',
  additionalRequestSentSuccessfully: 'Additional data request submitted successfully',

  validators: {
    onlyNumbers: 'Please enter numbers only',
    onlyArabicOrEnglishChars: 'Please enter arabic or english characters only',
  },
  serverErrors: {
    SERVER_ERROR: 'Something went wrong, please try again later',
  },
};

export default en;
